import { WeatherForecastPointSelectionState } from '@ebalance/proto/bfftypes/v1/weather_forecast_point_selection_state_pb'
import type {
  AreaWeatherForecastPoint,
  AreaWeatherForecastPointCandidates,
} from '@ebalance/proto/bffuser/v1/weather_forecast_point_model_pb'

import { AREA_CODE_OPTIONS } from '~/models/area'

import type { WeatherForecastPointRow } from './types'

/**
 * ListWeatherForecastPoints response から表示 row 配列へ変換する。
 * エリア順は conventions.md (北海道→沖縄) = AREA_CODE_OPTIONS の順序。
 *
 * 実効地点の解決 (保存値が候補外なら代表地点へ) は backend の
 * `valueobject.ResolveWeatherForecastPoint` が行い、 response の `locationName`
 * は常に候補リストに含まれる地点名になっている (AC-WFP-007)。 ここは並べ替えと
 * 候補リストの join だけを行い、 業務判断は持たない。
 */
export function convertListResponse(
  points: AreaWeatherForecastPoint[],
  candidates: AreaWeatherForecastPointCandidates[],
): WeatherForecastPointRow[] {
  const pointMap = new Map(points.map((p) => [p.areaCode, p]))
  const candidatesMap = new Map(candidates.map((c) => [c.areaCode, c]))

  return AREA_CODE_OPTIONS.map((areaCode) => {
    const point = pointMap.get(areaCode)
    return {
      areaCode,
      locationName: point?.locationName ?? '',
      candidates: (candidatesMap.get(areaCode)?.candidates ?? []).map((c) => ({
        locationName: c.locationName,
        isAvailable: c.isAvailable,
      })),
      selectionState:
        point?.selectionState ?? WeatherForecastPointSelectionState.UNSPECIFIED,
      updatedAt: point?.updatedAt,
      pendingLocationName: undefined,
    }
  })
}
